/* ==========================================================================
   Holofoil — animations.js
   Scroll-reveal via IntersectionObserver, per-group stagger, and a sticky
   header shadow on scroll. Fully guarded: if anything is unsupported or the
   visitor prefers reduced motion, all content is shown immediately.

   Exposes window.HolofoilAnimations.scan() so scripts that inject new markup
   (facets filtering, product recommendations) can reveal the new elements.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var supported = 'IntersectionObserver' in window;
  var observer = null;

  function revealNow(el) {
    el.classList.add('is-in');
  }

  function applyStagger() {
    var groups = document.querySelectorAll(
      '.product-grid, .tile-grid, .benefits, .testimonials-grid'
    );
    groups.forEach(function (group) {
      var items = group.querySelectorAll('.reveal:not(.is-in)');
      for (var i = 0; i < items.length; i++) {
        if (!items[i].style.transitionDelay) {
          items[i].style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
        }
      }
    });
  }

  // Reveal every not-yet-revealed .reveal element. Safe to call repeatedly and
  // after DOM is swapped in by AJAX.
  function scan() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.reveal:not(.is-in)'));
    if (nodes.length === 0) return;

    if (reduceMotion || !supported) {
      nodes.forEach(revealNow);
      return;
    }

    applyStagger();

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
    }

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initStickyHeader() {
    var header = document.querySelector('.header-wrapper--sticky');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  function init() {
    try {
      scan();
    } catch (e) {
      Array.prototype.slice
        .call(document.querySelectorAll('.reveal'))
        .forEach(revealNow);
    }
    initStickyHeader();

    // Safety net: reveal anything above the fold that never fired.
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 2500);
  }

  window.HolofoilAnimations = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when Shopify's theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function () {
    try {
      scan();
    } catch (e) {
      /* no-op */
    }
  });
})();
